import Button from '@/design_system/Button';
import { Column } from '@/design_system/Table/Table';
import IconArrow from '@/icons/Arrow.svg';
import { createBEMClasses } from '@/utils/classname';

import './SortableColumnHeader.css';

export const SortableColumnHeader = ({
  children,
  isActive,
  onChange,
  sortOrder,
}: {
  children?: React.ReactNode;
  isActive: boolean;
  onChange: () => void;
  sortOrder: 'asc' | 'desc';
}) => {
  const { block, element } = createBEMClasses('sortable-column');

  return (
    <Column className={block()}>
      <Button
        onClick={() => onChange()}
        variant="style-less"
        size="small"
        className={element('button')}
      >
        {children}
        <IconArrow
          className={element(
            'icon',
            { active: isActive, up: sortOrder === 'desc' },
            isActive ? 'text-success' : 'text-disabled'
          )}
          down
        />
      </Button>
    </Column>
  );
};
